import dayjs from "dayjs";
import { isString } from "./StringService";

function toDayjs(date = null) {
  if (date == null) {
    return dayjs();
  }

  if (isString(date) || date instanceof Date || dayjs.isDayjs(date)) {
    return dayjs(date);
  }

  return date;
}

/** returns string yyyy-mm-dd */
export function getToday() {
  return dayjs().format("YYYY-MM-DD");
}

/**
 * returns current day (if monday), or the previous monday
 */
export function getMonday() {
  const today = dayjs();
  const daysSinceMonday = (today.day() + 6) % 7;
  return today.subtract(daysSinceMonday, "day").format("YYYY-MM-DD");
}

export function getYYYYMMDD(date = null) {
  date = toDayjs(date);
  return date.format("YYYY-MM-DD");
}

export function getYYYYMMDD__JsDate(date) {
  return date.toISOString().split("T")[0];
}

export function convertToYYYYMMDD(dateStr) {
  const oDate = dayjs(dateStr);
  return oDate.format("YYYY-MM-DD");
}

export function getMD(dDate = null) {
  dDate = toDayjs(dDate);
  return dDate.format("M/D");
}

export function getMMDD(date = null) {
  date = toDayjs(date);
  return date.format("MM/DD");
}

// 1-12
export function getMonthNum(dDate = null) {
  dDate = toDayjs(dDate);
  return parseInt(dDate.format("M"));
}


export function getDay(dDate = null) {
  dDate = toDayjs(dDate);
  return dDate.format("dddd");
}

export function parseYYYYMMDD(dateStr) {
  return dayjs(dateStr);
}

function copyDate(dDate) {
  return dDate.clone();
}

export function subDayStr(dDate = null, dayCount) {
  dDate = toDayjs(dDate);

  const dNewDate = copyDate(dDate);
  return getYYYYMMDD(dNewDate.subtract(dayCount, "d"));
}

export function addDaysStr(dateStr, dayCount) {
  const mNewDate = dayjs(dateStr);
  return getYYYYMMDD(mNewDate.add(dayCount, "d"));
}

export function getTomorrow() {
  let mCurrentDate = dayjs().add(1, "d");
  return getYYYYMMDD(mCurrentDate);
}

export function isSameDate(dDate1, dDate2) {
  return dDate1.isSame(dDate2, "day");
}

export function getDifferenceInDays(dDate1, dDate2) {
  return dDate1.diff(dDate2, "day");
}

export function getThisWeeksMonday() {
  const dDate = dayjs().startOf("week").add(1, "day");
  return getYYYYMMDD(dDate);
}

export function getThisWeeksFriday() {
  const dDate = dayjs().startOf("week").add(5, "day");
  return getYYYYMMDD(dDate);
}

export function getThisWeeksSunday() {
  const dDate = dayjs().startOf("week");
  return getYYYYMMDD(dDate);
}

export function diffInDaysFiltered(startDate, endDate, acceptFn) {
  let count = 0;
  let current = new Date(startDate);

  while (current <= endDate) {
    if (acceptFn(current)) {
      count++;
    }
    current.setDate(current.getDate() + 1); // move to next day
  }

  return count;
}

export function countWeekdays(startDate, endDate) {
  let count = 0;
  let current = dayjs(startDate);
  const end = dayjs(endDate);

  while (current.isBefore(end) || current.isSame(end, "day")) {
    const day = current.day();
    // 0 = Sunday, 6 = Saturday
    if (day !== 0 && day !== 6) {
      count++;
    }
    current = current.add(1, "day");
  }

  return count;
}

/**
 * Get all dates between two dates (inclusive), excluding weekends
 * @param {string|Date|dayjs.Dayjs} start
 * @param {string|Date|dayjs.Dayjs} end
 * @returns {string[]} array of dates in YYYY-MM-DD format
 */
export const getBusinessDatesBetween = (start, end) => {
  const dates = [];

  let current = dayjs(start).startOf("day");
  const last = dayjs(end).startOf("day");

  while (current.isBefore(last, "day") || current.isSame(last, "day")) {
    const day = current.day(); // 0 = Sun, 6 = Sat

    if (day !== 0 && day !== 6) {
      dates.push(current);
    }

    current = current.add(1, "day");
  }

  return dates;
};

export function getDayJsDay(date = null) {
  if (date == null) {
    date = dayjs();
  }
  if (isString(date)) {
    date = dayjs(date);
  }
  return date.format("dddd");
}

export function getDayJsMD(date = null) {
  if (date == null) {
    date = dayjs();
  }
  if (isString(date)) {
    date = dayjs(date);
  }
  return date.format("M/D");
}
